module.exports = __webpack_public_path__ + "static/media/Logo blue.18e16288.png";